import { combineReducers } from 'redux';
import tags from './tags';
import projects from './projects';
import projectAction from './projectAction';
import user from './user';

console.log('reducers: ', combineReducers({
  tags,
  projects,
  user,
  projectAction
}))

export default combineReducers({
  tags,
  projects,
  user,
  projectAction
})



// WEBPACK FOOTER //
// ./src/reducers/index.js